import type { Scenario } from "../types";

export interface ConflictResolution {
  winner: Scenario;
  loser: Scenario;
  reason: "timestamp" | "local-authoritative";
}

function getUpdatedAt(s: Scenario): number {
  const raw = (s as unknown as Record<string, unknown>).updatedAt;
  if (typeof raw === "string" || typeof raw === "number") {
    return new Date(raw).getTime();
  }
  return 0;
}

export function resolveConflict(
  local: Scenario,
  remote: Scenario,
): ConflictResolution {
  const localTime = getUpdatedAt(local);
  const remoteTime = getUpdatedAt(remote);

  if (remoteTime >= localTime) {
    return { winner: remote, loser: local, reason: "timestamp" };
  }
  return { winner: local, loser: remote, reason: "local-authoritative" };
}
